module.exports = __webpack_public_path__ + "img/shaq.5e1e5c13.png";